import React from "react";
import { Bill } from "@common/types/bill";
import { BillDetails } from "@components/bills/BillDetails";
import { useBillDetailsHandlers } from "@components/bills/useBillDetailsHandlers";
import { DetailsAside } from "@design-system/DetailsAside/DetailsAside";

interface Props {
    workspaceId: string;
    bill: Bill;
    setBill: (bill?: Bill) => void;
}

/** Details aside of the bill clicked in a task's bills table. */
export const BillsTaskBillDetails: React.FC<Props> = ({
    workspaceId,
    bill,
    setBill,
}) => {
    const { handleUpdateMemo, handleUpdateStatus } = useBillDetailsHandlers({
        workspaceId,
        bill,
        setBill,
    });

    const { lines } = bill;
    if (!lines) {
        return null;
    }

    return (
        <DetailsAside>
            <BillDetails
                bill={{ ...bill, lines }}
                setBill={setBill}
                onUpdateMemo={handleUpdateMemo}
                onUpdateStatus={handleUpdateStatus}
            />
        </DetailsAside>
    );
};
